import {
  PageHeader,
  message,
  Tag,
} from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import {
  SegmentedItem,
  TableItemDinamico,
  dineroDisabledMask,
} from "../../../Components/Items";
import SelectClientesItem from "../../../Components/SelectClientesItem";
import ModalEditarDatosPortal from "./ModalEditarDatosPortal/ModalEditarDatosPortal";

class PortalClientes extends Component {
  tableRef = null;
  state = {
    loading: false,
    clienteSeleccionado: null,
    todasClientes: [],
    todasVentas: [],
    totalRecords: 0,
    valor: 5, // Filtro por defecto (Todos)
    textoFiltro: "",
    valorestadoPortal: 3, // Todos por defecto
    modalEditarPortal: false,
    ventaSeleccionada: null,
  };

  async onChangeCliente(valueId, clienteEncontrado) {
    try {
      this.setState({ loading: true });
      let cliente;

      if (clienteEncontrado) {
        cliente = clienteEncontrado;
        const yaExiste = this.state.todasClientes.find(
          (i) => i._id === cliente._id,
        );
        if (!yaExiste) {
          this.setState((prev) => ({
            todasClientes: [...prev.todasClientes, cliente],
          }));
        }
      } else {
        cliente = this.state.todasClientes.find((c) => c._id === valueId);
      }

      if (!cliente) {
        message.warning("No se encontró la información del cliente");
        return;
      }

      this.setState(
        {
          clienteSeleccionado: cliente,
          todasVentas: [],
          loading: false,
        },
        () => {
          if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
          }
        },
      );
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      message.error("Error al seleccionar el cliente");
    }
  }

  consultarVentas(params) {
    this.setState({ loading: true });
    const payload = {
      empresaId: this.props.empresaId,
      clienteId: this.state?.clienteSeleccionado?._id || null,
      clientePortal: true,
      ...params,
    };

    axios
      .post("ventas/selectVentas", payload, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasVentas: res.data.data.map((value) => {
              let numero = "";
              if (value.factura) {
                numero +=
                  (value.facturaSerie ? value.facturaSerie : "F") +
                  " " +
                  value.facturaNumero;
              }
              if (value.remision) {
                if (numero !== "") numero += " ";
                numero +=
                  (value.remisionSerie ? value.remisionSerie : "R") +
                  " " +
                  value.remisionNumero;
              }
              return {
                ...value,
                fechaVenta:
                  value.fechaVenta || value.fechaFactura || value.fechaRemision,
                numero: numero,
                clienteNombre: value.cliente.persona
                  ? value.cliente.razonSocial
                  : value.cliente.nombre +
                  " " +
                  value.cliente.apellidoPaterno +
                  " " +
                  value.cliente.apellidoMaterno,
                vendedor: value.vendedor
                  ? value.vendedor.nombre +
                  " " +
                  (value.vendedor.apellidoPaterno || "")
                  : "",
                accion: { ...value },
              };
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasVentas: [], totalRecords: 0, loading: false });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ loading: false });
      });
  }

  abrirModalEditarPortal(venta) {
    this.setState({
      modalEditarPortal: true,
      ventaSeleccionada: venta,
    });
  }

  cerrarModalEditarPortal(recargar = false) {
    this.setState({
      modalEditarPortal: false,
      ventaSeleccionada: null,
    });

    if (recargar && this.tableRef) {
      this.tableRef.fetchData();
    }
  }

  render() {
    const columns = [
      {
        title: "F/R",
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        render: (_, record) => (
          <div>
            <div style={{ fontSize: "12px" }}>{record.numero}</div>
            {record.ordenDeCompra && (
              <div style={{ fontSize: "10px", color: "#666" }}>
                OC: {record.ordenDeCompra}
              </div>
            )}
          </div>
        ),
        width: "15%",
      },
      {
        title: "Fecha de Venta",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        sorter: true,
        render: (value) => moment(value).format("DD/MM/YY HH:mm"),
        width: "15%",
      },
      {
        title: "Fecha de Vencimiento",
        dataIndex: "fechaVencimiento",
        key: "fechaVenciemiento",
        sorter: true,
        render: (value) => moment(value).format("DD/MM/YY HH:mm"),
        width: "15%",
      },
      {
        title: "Observaciones",
        dataIndex: "observacionesPortal",
        key: "observacionesPortal",
        width: "15%",
      },
      {
        title: "Cliente / Vendedor",
        dataIndex: "clienteNombre",
        key: "clienteNombre",
        buscar: "cliente",
        render: (_, record) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
              {record.clienteNombre}
            </span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              {record.vendedor || "-"}
            </span>
          </div>
        ),
        width: window.innerWidth >= 1800 ? "18%" : "20%",
        ellipsis: true,
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        sorter: true,
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "4px",
              }}
            >
              <span>{dineroDisabledMask(record.subtotal)}</span>
              {record.moneda && (
                <span style={{ fontSize: "12px", color: "#999" }}>
                  {record.moneda}
                </span>
              )}
            </div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "4px",
              }}
            >
              <span>{dineroDisabledMask(record.total)}</span>
              {record.moneda && (
                <span style={{ fontSize: "12px", color: "#666" }}>
                  {record.moneda}
                </span>
              )}
            </div>
          </div>
        ),
        buscar: "subtotal",
        width: "12%",
        ellipsis: true,
        align: "right",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        align: "center",
        render: (value, record) => {

          const estiloTag = {
            width: '14em',
            textAlign: 'center',
            display: 'inline-block',
            margin: 0
          };
          if (!record?.estadoPortal || record.estadoPortal === 0) {
            return <Tag color="#BFBFBF" style={estiloTag}>Sin Subir</Tag>
          }
          if (record?.estadoPortal === 1) {
            return <Tag color="gold" style={estiloTag}>Pendiente / Revisando</Tag>
          }
          if (record?.estadoPortal === 2) {
            return <Tag color="green" style={estiloTag}>Subir</Tag>
          }
        },
        width: "15%",
      },
    ];

    return (
      <>
        <PageHeader
          title="Portal de clientes"
          subTitle="Consulta y actualización de estado de sus facturas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <SelectClientesItem
              key="select-cliente"
              empresaId={this.props.empresaId}
              headersToken={this.props.headersToken}
              sinBorde
              autoFocus
              dropdownMatchSelectWidth={600}
              width="350px"
              placeholder="Buscar cliente..."
              onChange={(valueId, cliente) =>
                this.onChangeCliente(valueId, cliente)
              }
              clientePortal={true}
            />,
            <SegmentedItem
              options={[
                { label: "Sin Subir", value: 0 },
                { label: "Pendiente / Revisando", value: 1 },
                { label: "Subido", value: 2 },
                { label: "Todos", value: 3 },
              ]}
              onChange={(value) => {
                if (this.tableRef) {
                  this.tableRef.updateExternalFilters({
                    valorestadoPortal: value,
                  });
                }
                this.setState({ valorestadoPortal: value });
              }}
              value={this.state.valorestadoPortal}
            />,
          ]}
        />

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          onFetchData={this.consultarVentas.bind(this)}
          loading={this.state.loading}
          size="small"
          estadosLeyenda={[
            {
              color: "rgb(207, 207, 207)",
              label: "Sin Subir",
              key: "sin-subir",
            },
            {
              color: "rgb(255, 248, 145)",
              label: "Pendiente / Revisando",
              key: "pendiente-revisando",
            },
            {
              color: "rgb(145, 216, 127)",
              label: "Subido",
              key: "subido",
            },
          ]}
          dataSource={this.state.todasVentas}
          anadirValorFiltro={this.state.valor}
          columns={columns}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorTextoDefault={""}
          filterStorageKey={"portalClientes" + this.props.empresaId}
          pagination={false}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={5}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.abrirModalEditarPortal(record)
            },
          })}
          portalClasses={true}
        />
        <ModalEditarDatosPortal
          visible={this.state.modalEditarPortal}
          venta={this.state.ventaSeleccionada}
          onCancel={() => this.cerrarModalEditarPortal(false)}
          onSuccess={() => this.cerrarModalEditarPortal(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(PortalClientes);
